import Vue from "vue";
import entriesTransformer from "@/transformers/catalog/warehouse/entriesWithoutOC";
import moment from "moment";

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch entries without OC
 * @return {object}
 */

const paramsTransformer = (
  { iwarehouses = [], movementType, dateFrom, dateTo, movementReason, searchQuery, queryMode, headers = [], xls }
) => ({
  from: dateFrom ? moment(dateFrom).format("YYYY/MM/DD") : null,
  to: dateTo ? moment(dateTo).format("YYYY/MM/DD") : null,
  iwarehouses: iwarehouses.length ? iwarehouses.map(({id}) => id).join(',') : null,
  type_of_movement: movementType === "all" ? undefined : movementType,
  movement_reason: movementReason,
  supply_code: searchQuery && !queryMode ? searchQuery : undefined,
  sinister_number: searchQuery && queryMode ? searchQuery : undefined,
  headers: headers.length ? headers.join(',') : null,
  xls
});

export default (payload) => {
  const params =  paramsTransformer(payload)
  return Vue.$http.get(`iwarehouse/movement/`, { params: paramsTransformer(payload), responseType: payload.xls ? 'blob' : null, })
    .then(({ data }) => {
      if (!payload.xls) {
        return entriesTransformer.fetchCollection(data);
      } else {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `BITACORA_INVENTARIO_${params.from}_${params.to}.xls`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    });
}




// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchEntries.js